import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fcom-selectable-card-header',
  template: '<ng-content></ng-content>',
  styleUrls: ['./selectable-card-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectableCardHeaderComponent {}
